const safeStorage = {
  getItem: (key) => { try { return localStorage.getItem(key); } catch { return null; } },
  setItem: (key, val) => { try { localStorage.setItem(key, val); } catch {} },
  removeItem: (key) => { try { localStorage.removeItem(key); } catch {} },
  clear: () => { try { localStorage.clear(); } catch {} },
};

// Cookie helper utilities
export const cookieUtils = {
  set: (name, value, days = 7) => {
    try {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    } catch {}
  },
  get: (name) => {
    try {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    } catch { return null; }
  },
  remove: (name) => {
    try {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    } catch {}
  },
  clearAll: () => {
    try {
      document.cookie.split(';').forEach((c) => {
        const name = c.trim().split('=')[0];
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      });
    } catch {}
  },
};

export default safeStorage;
